(function ($, Drupal, drupalSettings, once) {

  'use strict';

  function _get_month() {
    var month = [];
    month[0] = 'January';
    month[1] = 'February';
    month[2] = 'March';
    month[3] = 'April';
    month[4] = 'May';
    month[5] = 'June';
    month[6] = 'July';
    month[7] = 'August';
    month[8] = 'September';
    month[9] = 'October';
    month[10] = 'November';
    month[11] = 'December';
    var d = new Date();
    return month[d.getMonth()];
  }

  Drupal.behaviors.analytics = {

    liftSegmentCheck: function () {
      var expValue = 'Undefined';
      var destValue = 'Undefined';
      var expValueSet = false;
      var destValueSet = false;
      var segments = [];

      if (typeof window.AcquiaLift !== 'undefined' && typeof window.AcquiaLift.currentSegments !== 'undefined') {
        $.each(window.AcquiaLift.currentSegments, function (index, value) {
          segments.push(value['id']);
        });
        if (segments != null) {
          $.each(segments, function (index, value) {
            if (value.indexOf('experience') >= 0) {
              expValueSet = true;
              expValue = value.replace('experience_', '');
              dataLayer.push({favoriteExperience: expValue});
            }
            if (value.indexOf('destination') >= 0) {
              destValueSet = true;
              destValue = value.replace('destination_', '');
              dataLayer.push({favoriteDestination: destValue});
            }
          });

          if (expValueSet === false) {
            dataLayer.push({favoriteExperience: expValue});
          }
          if (destValueSet === false) {
            dataLayer.push({favoriteDestination: destValue});
          }
        }
      }
      else {
        window.setTimeout(Drupal.behaviors.analytics.liftSegmentCheck, 500);
      }
    },

    hashString: function (string) {
      const utf8 = new TextEncoder().encode(string);
      return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, '0')).join('');
        return hashHex;
      });
    },

    attach: function (context, settings) {
      $(once('tnvacation_analytics_functions', 'body', context)).each(function () {
        Drupal.behaviors.analytics.liftSegmentCheck();

        setTimeout(function () {
          $(once('test', '.page-search .gs-snippet')).each(function () {
            var asset = $('#gsc-i-id2').val();
            var noResult = $(this).text();
            var action = noResult === 'No Results' ? 'no results' : 'successful search';

            dataLayer.push({
              eventCategory: 'search',
              eventAction: action,
              eventLabel: asset,
              eventvalue: '',
              event: 'eventClick'
            });
          });
        }, 3000);

        if (location.toString().indexOf('utm_source=Snapchat') !== -1) {
          if (document.hidden === false && $(document).data('vizTriggered') !== true) {
            $(document).data('vizTriggered', true);
            dataLayer.push({
              event: 'VirtualPageview',
              virtualPageURL: location.pathname + location.search + '&virtual=1',
              virtualPageTitle: document.title
            });
          }
          else {
            $(document).on('visibilitychange', function () {

              if (document.hidden === false && document.visibilityState === 'visible' && $(document).data('vizTriggered') !== true) {
                // set the flag to prevent further triggers
                $(document).data('vizTriggered', true);
                dataLayer.push({
                  event: 'VirtualPageview',
                  virtualPageURL: location.pathname + location.search + '&virtual=1',
                  virtualPageTitle: document.title
                });
              }
            });
          }
        }

        // Generic Google Analytics tracking
        $(once('analytics', '.js-tracking')).click(function () {
          var category = $(this).data('category');
          var action = $(this).data('action');
          var label = $(this).data('label');
          dataLayer.push({
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // URL Structure Tracking
        var pathArray = location.pathname.trim().split('/');
        var pageCategory = pathArray[1].length ? pathArray[1] : null;
        var pagesubCategory = null;
        if (2 in pathArray && pathArray[2].length) {
          pagesubCategory = pathArray[2];
        }
        dataLayer.push({
          pageCategory: pageCategory,
          pagesubCategory: pagesubCategory
        });

        $(once('analytics', '#block-views-blocklift-teasers-cityview a')).click(function () {
          var asset = $(this).find('h2').text();
          dataLayer.push({
            eventCategory: 'trip inspiration',
            eventAction: 'click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.nav-my-trip')).click(function () {
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'my trip',
            eventLabel: 'my trip',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.nav-calendar')).click(function () {
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'events',
            eventLabel: 'events',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.nav-email')).click(function () {
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'stay inspired',
            eventLabel: 'stay inspired',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '#nav_promo_snapchat a')).click(function () {
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'Plan Your Trip',
            eventLabel: 'snapchat',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.block-nav-promo-guide a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'featured',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '#block-megamenuforcitiesregions .region-container a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'Cities & Regions',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '#block-megamenuformytrip .menu a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'my trip',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.nav-cities-regions')).click(function () {
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'Cities & Regions',
            eventLabel: 'N/A',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.nav-experiences')).click(function () {
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'Experiences',
            eventLabel: 'N/A',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.nav-trip-planner')).click(function () {
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'Trip Planner',
            eventLabel: 'N/A',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Site Logo
        $(once('analytics', '#block-tnvacation-branding a')).click(function (e) {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: 'header logo',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Footer
        $(once('analytics', 'body:not(.biketn):not([class*="path-bill-dance-signature-lakes"]) .footer-sections .menu-item a')).click(function (e) {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'footer',
            eventAction: text,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.block-footerlogos a')).click(function (e) {
          var asset = $(this).attr('href');
          var text = $(this).attr('aria-label');
          dataLayer.push({
            eventCategory: 'footer',
            eventAction: text,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Footer - Vacation Guide CTA
        $(once('analytics', '.homepage-pre-footer--wrapper .vacation-guide a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'footer',
            eventAction: 'vacation guide',
            eventLabel: text + '- ' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Footer - Toy Catalog CTA
        $(once('analytics', '.homepage-pre-footer--wrapper .playcation a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'footer',
            eventAction: 'toy catalog',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Vacation Guide Request Form - Toy Catalog Opt-in
        $(once('analytics', '#webform-submission-vacation-guide-node-160411-add-form #edit-actions-submit')).click(function () {
          var email = $('#webform-submission-vacation-guide-node-160411-add-form #edit-field-guide-email').val();
          Drupal.behaviors.analytics.hashString(email).then(hash => {
            dataLayer.push({
              eventCategory: 'guide',
              eventAction: 'request',
              eventLabel: 'print',
              eventvalue: '',
              event: 'eventClick',
              hashedEmail: hash
            });
            if ($('#webform-submission-vacation-guide-node-160411-add-form .form-item-toy-catalog-opt-in .form-checkbox').is(':checked')) {
              dataLayer.push({
                eventCategory: 'guide',
                eventAction: 'request',
                eventLabel: 'playcation print guide order',
                eventvalue: '',
                event: 'eventClick',
                hashedEmail: hash
              });
            }
          });
        });
        // Vacation Guide Request Form - Toy Catalog link
        $(once('analytics', '#webform-submission-vacation-guide-node-160411-add-form .form-item-toy-catalog-opt-in a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'guide',
            eventAction: 'request',
            eventLabel: 'playcation info|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '#webform-submission-e-vacation-guide-node-160416-add-form')).click(function () {
          dataLayer.push({
            eventCategory: 'guide',
            eventAction: 'request',
            eventLabel: 'eguide',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-guide .gatag--digital-guide')).click(function () {
          dataLayer.push({
            eventCategory: 'guide',
            eventAction: 'request',
            eventLabel: 'eguide',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-guide-success .gatag--digital-guide')).click(function () {
          dataLayer.push({
            eventCategory: 'guide',
            eventAction: 'request',
            eventLabel: 'eguide',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.field--name-field-teaser-card-para .slick-next')).click(function () {
          var asset = window.location.pathname;
          dataLayer.push({
            eventCategory: 'slider-teaser-card',
            eventAction: 'click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.field--name-field-teaser-card-para .slick-prev')).click(function () {
          var asset = window.location.pathname;
          dataLayer.push({
            eventCategory: 'slider-teaser-card',
            eventAction: 'click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.view-experience-teasers .view-content .slick-next')).click(function () {
          var asset = window.location;
          dataLayer.push({
            eventCategory: 'slider-experience',
            eventAction: 'click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.view-experience-teasers .view-content .slick-prev')).click(function () {
          var asset = window.location;
          dataLayer.push({
            eventCategory: 'slider-experience',
            eventAction: 'click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '#edit-field-guide-email-opt-in-value')).click(function () {
          if ($(this).prop('checked') === true) {
            var asset = window.location.pathname;
            dataLayer.push({
              eventCategory: 'enewsletter',
              eventAction: 'sign-up',
              eventLabel: asset,
              eventvalue: '',
              event: 'eventClick'
            });
          }
        });
        $(once('analytics', '#form-email-signup')).on('submit', function () {
          var email = $('#form-email-signup #edit-emailmodal').val();
          if (email !== '') {
            Drupal.behaviors.analytics.hashString(email).then(hash => {
              dataLayer.push({
                eventCategory: 'enewsletter',
                eventAction: 'sign-up',
                eventLabel: 'stay inspired',
                eventvalue: '',
                event: 'eventClick',
                hashedEmail: hash
              });
            });
          }
        });

        // Homepage
        $(once('analytics', '.path-frontpage .field-name-field-article-embed-article a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'homepage',
            eventAction: 'read more',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Homepage - CTA Grid - Col 1
        $(once('analytics', '.component-campaign-grid--left .grid-item-1 a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).find('.component-campaign-grid-item__link.button').text();
          dataLayer.push({
            eventCategory: 'homepage',
            eventAction: 'hero click',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Homepage - CTA Grid - Col 2
        $(once('analytics', '.component-campaign-grid--right .component-campaign-grid-item a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).find('.component-campaign-grid-item__link.button').text();
          dataLayer.push({
            eventCategory: 'homepage',
            eventAction: 'hero click',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Ken Burns - Explore Pathways
        $(once('analytics', '.block-ken-burns-hero-block__content a.block-ken-burns-hero-block__button')).click(function () {
          var asset = $(this).attr('href');
          // Replace multiple spaces with a single space
          var text = $(this).text().trim().replace(/\s+/g, ' ');
          dataLayer.push({
            eventCategory: 'tmp- ken burns passport',
            eventAction: text,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Ken Burns - See The Destinations CTA
        $(once('analytics', '.block-passport-callout-band-block__content .destinations-link')).click(function () {
          var currentUrl = window.location.href;
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'see the destinations',
            eventLabel: currentUrl + '|' + asset,
            eventValue: '',
            event: 'eventClick'
          });
        });
        // Ken Burns - Play Video
        $(once('analytics', '.block-ken-burns-video-block__video-play-button')).click(function () {
          var text = $('.block-ken-burns-video-block__video-video-container iframe').attr('title');
          dataLayer.push({
            eventCategory: 'tmp- ken burns passport',
            eventAction: 'video play',
            eventLabel: text,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Ken Burns - Redeem | explore.tnvacation.com
        $(once('analytics', '.block-ken-burns-passport-redeem-band__content-text .white-box a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'tmp- ken burns passport',
            eventAction: 'redeem digital passport',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Ken Burns - Redeem | 'here' & 'this form'
        $(once('analytics', '.block-ken-burns-passport-redeem-band__content-text .heavy-print a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'tmp- ken burns passport',
            eventAction: 'redeem print passport',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Ken Burns - Redeem | Terms and Conditions & Privacy Policy
        $(once('analytics', '.block-ken-burns-passport-redeem-band__content-text .verify a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'tmp- ken burns passport',
            eventAction: 'redeem print passport',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Ken Burns - Passport Stamp Locations | Ken Burns Music Pathways & 16 Welcome centers
        $(once('analytics', '.view-ken-burns-passport-locations__header-content a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'tmp- ken burns passport',
            eventAction: 'passport stamp locations',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Ken Burns - Passport Stamp Locations | Specific Locations
        $(once('analytics', '.ken-burns-lp-passport-location-listing__partner-name a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'tmp- ken burns passport',
            eventAction: 'passport stamp locations',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Ken Burns - FAQ Open/Close
        $(once('analytics', '.path-tennessee-music-pathways-passport .component-accordion-item__title-wrapper')).click(function () {
          var status = $(this).attr('aria-selected') === 'true' ? 'open' : 'close';
          var asset = $(this).find('.component-accordion-item__title').text().trim();
          dataLayer.push({
            eventCategory: 'tmp- ken burns passport',
            eventAction: 'faq ' + status,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Sponsored Homehero
        $(once('analytics', 'a.button.home-hero-link.js-tracking')).click(function () {
          var buyer = $(this).parents('.node--type-home-hero').attr('data-ad-buyer');
          if (buyer === '' || typeof buyer == 'undefined') {
            buyer = 'undefined';
          }
          if (buyer !== 'undefined') {
            var asset = $(this).attr('href');
            dataLayer.push({
              eventCategory: 'journal ads',
              eventAction: 'sponsored home hero click',
              eventLabel: asset,
              event: 'eventClick',
              adBuyer: buyer,
              adMonth: _get_month()
            });
          }
        });

        // TripPlanner
        $(once('analytics', '.block-tnv-tripplanner-filters-form .form-item-location .pselect-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'my trip',
            eventAction: 'im going to',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.block-tnv-tripplanner-filters-form .form-item-category-parent .pselect-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'my trip',
            eventAction: 'im looking for',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.block-tnv-tripplanner-filters-form .form-item-category-child .pselect-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'my trip',
            eventAction: 'show me',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.block-tnv-tripplanner-filters-form .form-type-checkbox #edit-family-friendly')).click(function () {
          if ($(this).prop('checked') === true) {
            dataLayer.push({
              eventCategory: 'my trip',
              eventAction: 'family friendly',
              eventLabel: 'family friendly',
              eventvalue: '',
              event: 'eventClick'
            });
          }
        });
        $(once('analytics', '.view-tripplanner .pager__item .button')).click(function () {
          dataLayer.push({
            eventCategory: 'my trip',
            eventAction: 'load more',
            eventLabel: 'articles',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.view-tripplanner .view-content .js-tracking-boost')).click(function () {
          var title = $(this).data('title');
          var buyer = $(this).attr('data-ad-buyer');
          if (buyer === '' || typeof buyer == 'undefined') {
            buyer = 'undefined';
          }
          dataLayer.push({
            eventCategory: 'journal ads',
            eventAction: 'trip-planner boost',
            eventLabel: title,
            eventvalue: '',
            event: 'eventClick',
            adBuyer: title,
            adMonth: _get_month()
          });
        });

        // Plan Your Trip
        $(document).on('click', '.view-trip-planner .view-content .js-tracking-boost', function () {
          var title = $(this).data('title');
          var buyer = $(this).attr('data-ad-buyer');
          if (buyer === '' || typeof buyer == 'undefined') {
            buyer = 'undefined';
          }
          dataLayer.push({
            eventCategory: 'journal ads',
            eventAction: 'trip-planner boost',
            eventLabel: title,
            eventvalue: '',
            event: 'eventClick',
            adBuyer: buyer,
            adMonth: _get_month()
          });
        });

        // My Trip
        $(once('analytics', '#block-tnv-mytrip-no-saved-articles a')).click(function () {
          dataLayer.push({
            eventCategory: 'my trip',
            eventAction: 'click',
            eventLabel: 'get inspired',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.view-empty #block-mytrip-start-planning .custom-select.location .custom-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'my trip',
            eventAction: 'im going to',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.view-empty #block-mytrip-start-planning .custom-select.experience .custom-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'my trip',
            eventAction: 'im looking for',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.view-id-mytrip.view-display-id-partners .map-listing-link')).click(function () {
          var asset = $(this).parent().parent().find('h2').text();
          dataLayer.push({
            eventCategory: 'my trip',
            eventAction: 'partner site click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Experiences Home
        $(once('analytics', '.field--name-field-landing-page-content .view-experience-teasers .views-row a')).click(function () {
          var asset = $(this).attr('href');
          asset = asset.replace('/experiences/', '').replace('-', ' ');

          // Check if the current URL contains "/canada"
          var eventCategory = window.location.pathname.includes('/canada') ? 'canada' : 'experiences';
          dataLayer.push({
            eventCategory: eventCategory,
            eventAction: 'select experience',
            eventLabel: asset,
            eventValue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '#block-tnv-el-filters .pselect-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'experiences',
            eventAction: 'trip inspiration experience',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.view-experience-landing-articles .pager__item a')).click(function () {
          dataLayer.push({
            eventCategory: 'experiences',
            eventAction: 'load more',
            eventLabel: 'articles',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Experiences Detail Page
        $(once('analytics', '.page-node-type-experience .paragraph--type-teaser-cards a')).click(function () {
          var asset = $(this).find('h3').text().trim();
          var url = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'experiences',
            eventAction: 'find more',
            eventLabel: `${asset}|${url}`,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // page-node-type-experience
        Array.from($(once('analytics', '.page-node-type-experience span.read-more'))).forEach((el) => {
          $(el).closest('a').on('click', function (e) {
            var asset = $(this).attr('href');
            dataLayer.push({
              eventCategory: 'experiences',
              eventAction: 'view article',
              eventLabel: asset,
              eventvalue: '',
              event: 'eventClick'
            });
          });
        });
        // Event Pages
        $(once('analytics', '.page-node-type-event .operational-info .get-directions')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'get directions',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .buy-tickets')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'buy tickets',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .field-fb-rsvp a')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'rsvp on facebook',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .group-partner-cta .visit-site')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'partner site click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .field--name-field-event-phone a')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'partner call',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .field-name-field-partner-contact-email a')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'partner click to email',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .field--name-field-event-address a')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'event',
            eventAction: 'event address click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .field-email-signup a')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'partner email sign up',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .icon-twitter')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'partner twitter',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .icon-facebook')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'partner facebook',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .icon-instagram')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'partner instagram',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-event .section.intro .content-reveal-toggle')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'read more',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Cities & Regions
        $(once('analytics', '.cities-regions-map > a')).click(function () {
          var asset = $(this).find('.city-label').text();
          dataLayer.push({
            eventCategory: 'cities and regions',
            eventAction: 'map click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.cities-regions-map > svg > a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'cities and regions',
            eventAction: 'map click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '#block-list-cities-regions .region-column a')).click(function () {
          var asset = $(this).data('city');
          dataLayer.push({
            eventCategory: 'cities and regions',
            eventAction: 'city selection',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '#block-tnv-nav-citysearch-form')).click(function () {
          if ($('.page-cities-regions').length) {
            var asset = $(this).find('input[name="nav_city_search"]').val();
            dataLayer.push({
              eventCategory: 'cities and regions',
              eventAction: 'city search',
              eventLabel: asset,
              eventvalue: '',
              event: 'eventClick'
            });
          }
        });
        $(once('analytics', '#ui-id-1 .ui-menu-item')).click(function () {
          if ($('.page-cities-regions').length) {
            dataLayer.push({
              eventCategory: 'cities and regions',
              eventAction: 'city search',
              eventLabel: $(this).find('span').text(),
              eventvalue: '',
              event: 'eventClick'
            });
          }
          if ($('.event-calendar').length) {
            var asset = $(this).find('span').text();
            dataLayer.push({
              eventCategory: 'calendar',
              eventAction: 'im going to',
              eventLabel: asset,
              eventvalue: '',
              event: 'eventClick'
            });
          }
        });
        $(once('analytics', '#ui-id-2 a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'cities and regions',
            eventAction: 'city search',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // City Detail Pages
        $(once('analytics', '.section.eat-stay-do .view-content .js-tracking-boost')).click(function () {
          var title = $(this).data('title');
          var buyer = $(this).attr('data-ad-buyer');
          if (buyer === '' || typeof buyer == 'undefined') {
            buyer = 'Undefined';
          }
          dataLayer.push({
            eventCategory: 'journal ads',
            eventAction: 'eat-stay-do boost',
            eventLabel: title,
            eventvalue: '',
            event: 'eventClick',
            adBuyer: buyer,
            adMonth: _get_month()
          });
        });

        // Partner Pages
        $(once('analytics', '.page-node-type-partner .content-reveal-toggle')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'read more',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .button.get-directions')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'partner get directions',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .field--name-field-partner-address a')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'partner address click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .field-name-field-partner-contact-email a')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'click to email',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .field--name-field-partner-contact-phone a')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'partner call',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .button.email-signup')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'partner email signup',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .field--name-field-partner-contact-email a')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'partner click to email',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .buy-tickets')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'buy tickets',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .icon-twitter')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'partner twitter',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .icon-facebook')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'partner facebook',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .icon-instagram')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'partner instagram',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-partner .icon-youtube')).click(function () {
          var asset = $('.hero-overlay h1').text();
          dataLayer.push({
            eventCategory: 'partners',
            eventAction: 'partner youtube',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.page-node-type-event .view-content .row a')).click(function (e) {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'related articles',
            eventLabel: `Read More|${asset}`,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Articles
        $(once('analytics', '.page-node-type-article .icon-twitter')).click(function () {
          var asset = this.href;
          dataLayer.push({
            eventCategory: 'articles',
            eventAction: 'share twitter',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-article .icon-pinterest')).click(function (e) {
          var asset = this.href;
          dataLayer.push({
            eventCategory: 'articles',
            eventAction: 'share pinterest',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-article .icon-facebook')).click(function () {
          var asset = this.href;
          dataLayer.push({
            eventCategory: 'articles',
            eventAction: 'share facebook',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-article .icon-email')).click(function () {
          var asset = this.href;
          dataLayer.push({
            eventCategory: 'articles',
            eventAction: 'share email',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-article .icon-instagram')).click(function () {
          var asset = this.href;
          dataLayer.push({
            eventCategory: 'events',
            eventAction: 'share instagram',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-article .node--view-mode-article-summary a')).click(function () {
          var asset = $('.node--view-mode-article-summary h2 a').text();
          dataLayer.push({
            eventCategory: 'articles',
            eventAction: 'read more',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.page-node-type-article .paragraph--type-article-text-block a')).click(function () {
          var asset = $(this).attr('href');
          if (asset.charAt(0) !== '#') {
            dataLayer.push({
              eventCategory: 'articles',
              eventAction: 'partner site click',
              eventLabel: asset,
              eventvalue: '',
              event: 'eventClick'
            });
          }
        });
        $(once('analytics', '.itinerary-actions a')).click(function () {
          var asset = $(this).parent().parent().find('h2').text();
          dataLayer.push({
            eventCategory: 'article itenerary',
            eventAction: 'read more',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Sponsored Articles
        $(once('analytics', 'a.node--type-article.node--view-mode-teaser')).click(function () {
          var buyer = $(this).attr('data-ad-buyer');
          if (buyer === '' || typeof buyer == 'undefined') {
            buyer = 'undefined';
          }
          if (typeof buyer !== 'undefined') {
            var asset = $(this).find('h2').text();
            dataLayer.push({
              eventCategory: 'journal ads',
              eventAction: 'sponsored article click',
              eventLabel: asset,
              event: 'eventClick',
              adBuyer: buyer,
              adMonth: _get_month()
            });
          }
        });

        // Trails.
        $(once('analytics', '.node--type-trail .listing .pselect-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'trails',
            eventAction: 'point of interest',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.node--type-trail .app-button a')).click(function () {
          var asset = $(this).children('img').attr('alt');
          dataLayer.push({
            eventCategory: 'trails',
            eventAction: 'click to download',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Retire Tennessee.
        $(once('analytics', '.retire-tn #site-header .outer-wrapper .menu--retire-tennessee-main-navig a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: asset,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.retire-tn #site-header .outer-wrapper .menu--retire-tennessee-utility a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'navigation',
            eventAction: asset,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.retire-tn .community-filter .form-item-location .pselect-select-options a')).click(function () {
          var asset = $(this).text().trim();
          dataLayer.push({
            eventCategory: 'retire tn- community',
            eventAction: 'region drop down',
            eventLabel: asset,
            eventValue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.retire-tn .community-filter .form-item-category .pselect-select-options a')).click(function () {
          var asset = $(this).text().trim();
          dataLayer.push({
            eventCategory: 'retire tn- community',
            eventAction: 'interest drop down',
            eventLabel: asset,
            eventValue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.retire-tn .retire-map-overlay a')).click(function () {
          var asset = $(this).children('span').text().trim();
          dataLayer.push({
            eventCategory: 'retire tn- community',
            eventAction: 'map click',
            eventLabel: asset,
            eventValue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.retire-tn .contact-block-email')).click(function () {
          dataLayer.push({
            eventCategory: 'contact us',
            eventAction: 'click',
            eventLabel: 'email',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.retire-tn .contact-block-phone')).click(function () {
          dataLayer.push({
            eventCategory: 'contact us',
            eventAction: 'click',
            eventLabel: 'call',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.retire-tn .block-tn-retire-core-more-info .button')).click(function () {
          dataLayer.push({
            eventCategory: 'contact us',
            eventAction: 'click',
            eventLabel: 'request information',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '#eform-submission-retire-tennessee-contact-form')).click(function () {
          dataLayer.push({
            eventCategory: 'request information',
            eventAction: 'submit',
            eventLabel: 'request information',
            eventvalue: '',
            event: 'eventClick'
          });

          if ($('#edit-field-retire-tn-contact-tn-optin-value').prop('checked') === true) {
            dataLayer.push({
              eventCategory: 'enewsletter opt-in',
              eventAction: 'submit',
              eventLabel: 'request information',
              eventvalue: '',
              event: 'eventClick'
            });
          }

          $('#edit-field-retire-tn-contact-counties input').each(function () {
            if ($(this).prop('checked') === true) {
              var asset = $(this).parent().find('label').text();
              dataLayer.push({
                eventCategory: 'request information',
                eventAction: 'community interest',
                eventLabel: asset,
                eventvalue: '',
                event: 'eventClick'
              });
            }
          });
        });

        // Retire Tennessee - Community Page
        $(once('analytics', '.retire-tn.path-communities .view-community-listing .view-content .views-row')).find('a').click(function () {
          var asset = $(this).find('h2.teaser-title').text().trim();
          dataLayer.push({
            eventCategory: 'retire tn- community',
            eventAction: 'county selection',
            eventLabel: asset,
            eventValue: '',
            event: 'eventClick'
          });
        });

        // Retire Tennessee - County Page
        $(once('analytics', '.page-node-type-retirement-community .community-content-wrapper .community-content .community-content-left a')).click(function () {
          var asset = $(this).attr('href');
          if (asset.charAt(0) !== '#') {
            dataLayer.push({
              eventCategory: 'retire tn- county',
              eventAction: 'visit county website',
              eventLabel: asset,
              eventValue: '',
              event: 'eventClick'
            });
          }
        });

        $(once('analytics', '.page-node-type-retirement-community .community-content-wrapper .community-content .community-content-left a')).click(function () {
          var asset = $(this).attr('href');
          if (asset.charAt(0) !== '#') {
            dataLayer.push({
              eventCategory: 'outbound',
              eventAction: 'click',
              eventLabel: asset,
              eventValue: '',
              event: 'eventClick'
            });
          }
        });

        $(once('analytics', '.page-node-type-retirement-community .field--name-field-rc-post-content .paragraph-item--tour-guide .tour-pdf-info a')).click(function () {
          var asset = $(this).attr('href');
          if (asset.charAt(0) !== '#') {
            dataLayer.push({
              eventCategory: 'retire tn- county',
              eventAction: 'download pdf',
              eventLabel: asset,
              eventValue: '',
              event: 'eventClick'
            });
          }
        });

        $(once('analytics', '#calculator-form #edit-calc')).click(function () {
          dataLayer.push({
            eventCategory: 'cost of living',
            eventAction: 'submit',
            eventLabel: 'calculate',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.retire-tn .custom-select.location .custom-select-options')).find('a').click(function (e) {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'retire tn- homepage',
            eventAction: 'region drop down',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.retire-tn .custom-select.category .custom-select-options')).find('a').click(function (e) {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'retire tn- homepage',
            eventAction: 'interest drop down',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.retire-tn .retire-map-section .retire-map-cta a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'retire tn- homepage',
            eventAction: 'see all communities',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.retire-tn .cost-promo-content a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'retire tn- homepage',
            eventAction: 'calculate',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Calendar.
        $(once('analytics', '.block-tnv-calendar-filters-form .form-item-location .pselect-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'calendar',
            eventAction: 'im going to',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.block-tnv-calendar-filters-form .form-item-category-child .pselect-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'calendar',
            eventAction: 'show me',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.block-tnv-calendar-filters-form #edit-family-friendly')).click(function () {
          if (this.checked) {
            dataLayer.push({
              eventCategory: 'calendar',
              eventAction: 'family friendly',
              eventLabel: 'family friendly',
              eventvalue: '',
              event: 'eventClick'
            });
          }
        });

        // Tennessee Music Pathways
        $(once('analytics', '.tmp-explore-music')).click(function () {
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'click to explore music',
            eventLabel: 'explore music',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '#form-email-text-block-signup')).click(function () {
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'click to submit email',
            eventLabel: 'submit email',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.node--pathway-slide a')).click(function () {
          var asset = $(this).find('h2').text();
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'tmp genre selection',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.pathways-landing .component-grid-item a')).click(function () {
          var asset = $(this).find('.grid-item-title h2').text();
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'tmp curated pathway selection',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.pathways-landing .tmp-plan-your-path')).click(function () {
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'click to plan your path',
            eventLabel: 'plan your path',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.six-degrees-cta')).click(function () {
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'visit site',
            eventLabel: 'tmp to 6degrees site',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.tnv-pathway-filters-form .form-item-pathway .pselect-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'im interested in',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.tnv-pathway-filters-form .form-item-filter .poptions__group-item input')).click(function () {
          var asset = $(this).parent().find('label').text();
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'I\'m interested in',
            eventLabel: asset,
            eventValue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.tnv-pathway-filters-form .form-item-going .pselect-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'im going to',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.tnv-pathway-filters-form .form-item-coming .pselect-select-options a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'im coming from',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.tnv-pathway-filters-form .form-item-coming-road-trip span')).click(function () {
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'taking a road trip',
            eventLabel: 'taking a road trip',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.component-pathway__content')).on('click', '.pathway-location-detail__content-buttons-button--more-info', function () {
          var asset = $(this).closest('.pathway-location-detail').find('h1.pathway-location-detail__title-label').text();
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'map- learn more',
            eventLabel: asset,
            eventValue: '',
            event: 'eventClick'
          });
        });

        // Added event delegation as dynamic contents are loaded after the page load
        $(document).on('click', 'ul.pathway-location-detail-featured-on__list li a', function () {
          var asset = $('ul.pathway-location-detail-featured-on__list li a').attr('href');
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'map- featured on',
            eventLabel: asset,
            eventValue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.component-pathways-callout__list-toggle-group .toggle--more')).click(function () {
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'see more',
            eventLabel: 'tmp featured see more',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.component-pathways-callout .button')).click(function () {
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'learn more',
            eventLabel: 'tmp featured learn more',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.path-tennessee-music-pathways .component-block-embed-card .component-block-embed-card__container')).click(function () {
          var asset = $(this).find('.component-block-embed-card__content-overlay .field--name-field-formatted-title').text();
          dataLayer.push({
            eventCategory: 'tmp',
            eventAction: 'card selection',
            eventLabel: asset,
            eventValue: '',
            event: 'eventClick'
          });
        });

        $(once('analytics', '.path-bill-dance-signature-lakes-contact .contact-info .email a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'click to email',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-bill-dance-signature-lakes-contact .contact-info .office a')).click(function () {
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'click for directions',
            eventLabel: '312 Rosa L. Parks Ave. Nashville, TN 37243',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-bill-dance-signature-lakes-contact .tel-link')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'click to call',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-bill-dance-signature-lakes-contact .email-link')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'click to email',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-bill-dance-signature-lakes-contact .location-link')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'click for directions',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.bill-dance-signature-lakes #block-sitebranding-2 a')).click(function () {
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'navigation',
            eventLabel: 'header logo',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.menu--bill-dance-main-navigation a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'navigation',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.paragraph-item--bill-dance-lake-spotlight a')).click(function () {
          var asset = $(this).find('.teaser-title').text().trim();
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'featured',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.view-bill-dance-explore-lakes .views-row a')).click(function () {
          var asset = $(this).find('.teaser-title').text().trim();
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'explore the lakes',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.paragraph-item--article-text-block.bill-dance--signature-lakes a')).click(function () {
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'signature lakes',
            eventLabel: 'see more lakes',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('lakemapanalytics', 'body')).on('click', '.block-lakes-map .lake-pin', function () {
          var asset = $(this).data('title');
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'map click',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.view-bill-dance-lakes .views-row a')).click(function () {
          var asset = $(this).parent().find('h3').text().trim();
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'learn more',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '#lake-page--tabbed-nav a')).click(function () {
          var asset = $(this).text();
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'navigation',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.field--name-field-more-lakes .field__item a')).click(function () {
          var asset = $(this).find('h3').text().trim();
          dataLayer.push({
            eventCategory: 'bill dance',
            eventAction: 'more lakes',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        $(once('regionCheckAnalytics', '#region-list .filter--checkbox')).change(function () {
          if ($(this).prop('checked') === true) {
            var asset = 'All';
            if ($(this).val() !== 'All') {
              asset = $(this).next('label').text();
            }

            dataLayer.push({
              eventCategory: 'bill dance',
              eventAction: 'region',
              eventLabel: asset,
              eventvalue: '',
              event: 'eventClick'
            });
          }
        });
        $(once('fishCheckAnalytics', '#fish-type-list .filter--checkbox')).change(function () {
          if ($(this).prop('checked') === true) {
            var asset = 'All';
            if ($(this).val() !== 'All') {
              asset = $(this).next('label').text();
            }

            dataLayer.push({
              eventCategory: 'bill dance',
              eventAction: 'type of fish',
              eventLabel: asset,
              eventvalue: '',
              event: 'eventClick'
            });
          }
        });
        $(once('sizeCheckAnalytics', '#res-size-list .filter--checkbox')).change(function () {
          if ($(this).prop('checked') === true) {
            var asset = 'All';
            if ($(this).val() !== 'All') {
              asset = $(this).next('label').text();
            }

            dataLayer.push({
              eventCategory: 'bill dance',
              eventAction: 'reservior size',
              eventLabel: asset,
              eventvalue: '',
              event: 'eventClick'
            });
          }
        });
        // Little TN
        $(once('analytics', '.path-littletn .component-cta-w-image:not(.full-schedule) .button:first-of-type')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'little tn',
            eventAction: 'directions',
            eventLabel: asset,
            eventvalue: 'event',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-littletn .component-cta-w-image:not(.full-schedule) .button:last-of-type')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'little tn',
            eventAction: 'rsvp',
            eventLabel: asset,
            eventvalue: 'event',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-littletn .component-cta-w-image.full-schedule .button')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'little tn',
            eventAction: 'program schedule',
            eventLabel: asset,
            eventvalue: 'event',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-littletn .drake-hotel .button')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'little tn',
            eventAction: 'rsvp',
            eventLabel: asset,
            eventvalue: 'event',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-littletn .visit-tennessee .button')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'little tn',
            eventAction: 'start planning',
            eventLabel: asset,
            eventvalue: 'event',
            event: 'eventClick'
          });
        });

        // Little TN - FAQ Open/Close
        $(once('analytics', '.path-littletn .component-accordion-item__title-wrapper')).click(function () {
          var status = $(this).attr('aria-selected') === 'true' ? 'open' : 'close';
          var asset = $(this).find('.component-accordion-item__title').text().trim();
          dataLayer.push({
            eventCategory: 'little tn',
            eventAction: 'faq ' + status,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Trip Inspiration - Submit Filters
        $(once('analytics', '.path-trip-inspiration .apply-filters-toggle a')).click(function () {
          var values = [];

          // Sort Parameters
          values.push($('.path-trip-inspiration .sort-by .filter-value.active').text());

          // Region, Season & Category
          $('.path-trip-inspiration .filter-group:not(.sort-by)').each(function () {
            // Check for View All
            if ($(this).find('input[name$="-all"]').is(':checked')) {
              var taxonomy = $(this).find('input[name$="-all"]').attr('name').replace('-all', '');
              taxonomy = (taxonomy === 'cat') ? 'category' : taxonomy;
              values.push('view all- ' + taxonomy);
            }
            // Gather Individual Terms
            else {
              // eslint-disable-next-line
              $(this).find('input:checked + label').each(function () {
                values.push($(this).text());
              });
            }
          });

          var asset = values.join('|');
          dataLayer.push({
            eventCategory: 'trip inspiration',
            eventAction: 'article landing page filter',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Canada Landing Page - Articles
        $(once('analytics', '.landing-page--canada .view-article-teasers .views-row a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'canada',
            eventAction: 'article carousel',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Canada Landing Page - Airline FAQs
        $(once('analytics', '.landing-page--canada .canada-airlines a')).click(function () {
          var asset = $(this).attr('href');
          var title = $(this).text();
          dataLayer.push({
            eventCategory: 'canada',
            eventAction: 'airlines',
            eventLabel: title + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Canada Landing Page - FAQ Open/Close
        $(once('analytics', '.landing-page--canada .component-accordion-item__title-wrapper')).click(function () {
          var status = $(this).attr('aria-selected') === 'true' ? 'open' : 'close';
          var asset = $(this).find('.component-accordion-item__title').text().trim();
          dataLayer.push({
            eventCategory: 'canada',
            eventAction: 'faq ' + status,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Canada Landing Page - City Clicks
        $(once('analytics', '.landing-page--canada .component-content-pod-pea a')).click(function () {
          var title = $(this).find('h3').text();
          dataLayer.push({
            eventCategory: 'canada',
            eventAction: 'cities',
            eventLabel: title,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Canada Landing Page - Hero Anchors
        $(once('analytics', '.landing-page--canada a.hero-link')).click(function () {
          var title = $(this).text();
          dataLayer.push({
            eventCategory: 'canada',
            eventAction: 'header anchor',
            eventLabel: title,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Trip Inspiration - Clear All Filters
        $(once('analytics', '.path-trip-inspiration .clear-filters-toggle a')).click(function () {
          dataLayer.push({
            eventCategory: 'trip inspiration',
            eventAction: 'article landing page filter',
            eventLabel: 'clear all',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Trip Inspiration - Featured Articles Selection
        $(once('analytics', '.path-trip-inspiration .component-featured-articles-listing a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'trip inspiration',
            eventAction: 'select featured',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Trip Inspiration - Trending Articles Selection
        $(once('analytics', '.path-trip-inspiration .view-display-id-trending a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'trip inspiration',
            eventAction: 'select trending',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Trip Inspiration - Newest Articles Selection
        $(once('analytics', '.path-trip-inspiration .view-display-id-newest .view-content a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'trip inspiration',
            eventAction: 'select newest',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Trip Inspiration - Back to Top
        $(once('analytics', '.path-trip-inspiration .article-results a')).click(function () {
          dataLayer.push({
            eventCategory: 'trip inspiration',
            eventAction: 'select newest',
            eventLabel: 'Back To Top',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Toy Catalog - Homepage - Catalog CTA
        $(once('analytics', '.path-playcation .paragraph-item--toy-catalog-catalog-cta a')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'playcation- homepage',
            eventAction: 'main CTA',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Homepage - See More CTA
        $(once('analytics', '.path-playcation .tc-card a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'playcation- homepage',
            eventAction: 'see more',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - FAQ Open/Close
        $(once('analytics', '.path-playcation .component-accordion-item__title-wrapper')).click(function () {
          var status = $(this).attr('aria-selected') === 'true' ? 'open' : 'close';
          var asset = $(this).find('.component-accordion-item__title').text().trim();
          dataLayer.push({
            eventCategory: 'playcation- catalog',
            eventAction: 'faq ' + status,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Kid's Guide Page - FAQ Open/Close
        $(once('analytics', '.path-playcation-catalog .component-accordion-item__title-wrapper')).click(function () {
          var status = $(this).attr('aria-selected') === 'true' ? 'open' : 'close';
          var asset = $(this).find('.component-accordion-item__title').text().trim();
          dataLayer.push({
            eventCategory: 'playcation- catalog',
            eventAction: 'faq ' + status,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Destination Page - Plan Your Trip CTA
        $(once('analytics', '.page-node-type-toy-catalog-destination-page .section--title-intro .button')).click(function () {
          var asset = $(this).attr('href');
          asset = asset.substring(0, asset.indexOf('?'));
          dataLayer.push({
            eventCategory: 'playcation- location pages',
            eventAction: 'plan your trip',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Destination Page - Kid Reviewed Banner
        $(once('analytics', '.page-node-type-toy-catalog-destination-page .section--kr-banner a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'playcation- location pages',
            eventAction: 'read the reviews',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Destination Page - Buy Now CTA
        $(once('analytics', '.page-node-type-toy-catalog-destination-page .section--toys .button')).click(function () {
          var asset = $(this).attr('href');
          var title = $('.page-node-type-toy-catalog-destination-page .secondary-title').text();
          dataLayer.push({
            eventCategory: 'playcation- location pages',
            eventAction: 'buy now',
            eventLabel: title + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Destination Page - See All Destinations CTA
        $(once('analytics', '.page-node-type-toy-catalog-destination-page .section--see-all-destinations a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'playcation- location pages',
            eventAction: 'see all destinations',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Catalog Page - Digital Catalog CTA
        $(once('analytics', '.path-playcation-catalog .guidebook-lead-in--right a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'playcation- catalog',
            eventAction: 'digital',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // digital guide CTA click
        $(once('analytics', '.path-playcation-catalog .paragraph-content-wrapper .col:nth-child(2) a.button')).click(function (e) {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'playcation- catalog',
            eventAction: 'digital',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        $(once('analytics', '.path-playcation-catalog-success .paragraph-content-wrapper a')).click(function (e) {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'playcation- catalog',
            eventAction: 'digital',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });


        // Toy Catalog - Catalog Page - Out of Stock
        $(once('analytics', '.path-playcation-catalog .guidebook-lead-in--left.out-of-stock a')).click(function (e) {
          dataLayer.push({
            eventCategory: 'playcation- catalog',
            eventAction: 'print interest (out of stock)',
            eventLabel: 'out of stock',
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Toy Catalog - Catalog Page - Digital Catalog CTA
        $(once('analytics', '.path-playcation-catalog-out-of-stock .out-of-stock-wrapper a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'playcation- catalog',
            eventAction: 'digital',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Catalog Page - Digital Catalog CTA
        $(once('analytics', '.path-playcation-catalog #edit-guide-suffix p:first-child a')).click(function () {
          var asset = $(this).attr('href');
          var label = $(this).text();
          dataLayer.push({
            eventCategory: 'playcation- catalog',
            eventAction: 'playcation butterfly ticket sweepstakes- official rules',
            eventLabel: label + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Catalog Page - Vacation Guide Opt-in
        $(once('analytics', '#webform-submission-playcation-print-guidebook-node-245606-add-form #edit-actions-submit')).click(function () {
          var asset = $(this).attr('value');
          var email = $('#webform-submission-playcation-print-guidebook-node-245606-add-form #edit-email').val();
          Drupal.behaviors.analytics.hashString(email).then(hash => {
            dataLayer.push({
              eventCategory: 'playcation- catalog',
              eventAction: 'playcation print guide order',
              eventLabel: asset,
              eventvalue: '',
              event: 'eventClick',
              hashedEmail: hash
            });
            if ($('#webform-submission-playcation-print-guidebook-node-245606-add-form .form-item-vacation-guide-opt-in .form-checkbox').is(':checked')) {
              dataLayer.push({
                eventCategory: 'playcation- catalog',
                eventAction: 'vacation guide',
                eventLabel: 'vacation print guide order opt in',
                eventvalue: '',
                event: 'eventClick',
                hashedEmail: hash
              });
            }
            if ($('#webform-submission-playcation-print-guidebook-node-245606-add-form .form-item-email-optin-dollywood .form-checkbox').is(':checked')) {
              dataLayer.push({
                eventCategory: 'playcation- catalog',
                eventAction: 'playcation print guide order',
                eventLabel: 'dollywood email opt in',
                eventvalue: '',
                event: 'eventClick'
              });
            }
          });
        });
        // Toy Catalog - Catalog Success Page - Digital Catalog CTA
        $(once('analytics', '.path-playcation-catalog-success .success-text a')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'playcation- catalog',
            eventAction: 'digital',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Catalog Success Page - Need More Inspiration Carousel
        $(once('analytics', '.path-playcation-catalog-success .view-display-id-block_5 a.teaser-type-article')).click(function (e) {
          var asset = $(this).attr('href');
          var text = $(this).find('.button').text();

          dataLayer.push({
            eventCategory: 'need more inspiration carousel',
            eventAction: text,
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Footer - TN LOGO
        $(once('analytics', '.block-toycatalogfooter .col-3 a:not(.privacy)')).click(function () {
          dataLayer.push({
            eventCategory: 'playcation- universal',
            eventAction: 'footer',
            eventLabel: 'made in tn logo',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Footer - TC Logo
        $(once('analytics', '.block-toycatalogfooter .col-2 a:first-child')).click(function () {
          dataLayer.push({
            eventCategory: 'playcation- universal',
            eventAction: 'footer',
            eventLabel: 'playcation logo',
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - Footer - Privacy Policy CTA
        $(once('analytics', '.block-toycatalogfooter .col-3 a.privacy')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'playcation- universal',
            eventAction: 'privacy policy',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Toy Catalog - CTA Band - Family Experience page
        $(once('analytics', '.path-experiences-family .block--tc-callout-band .button')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'experiences',
            eventAction: 'toy catalog',
            eventLabel: text + '- ' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Kid Reviewed Page - CTA Banner - Updated July 2024
        $(once('analytics', '.path-kidreviewed .block--tc-callout-band .button')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'kid reviewed',
            eventAction: 'homepage banner',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Kid Reviewed Page - CTA Banner (Alt)  - Added July 2024
        $(once('analytics', '.page-node-type-kid-reviewed-partner-page .block-tc-callout-band-alt .button')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'kid reviewed',
            eventAction: 'partner page banner',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
        // Playcation Page - CTA Banner - Updated Nov 2024
        $(once('analytics', '.path-experiences-family-playcation .block--tc-callout-band .button')).click(function () {
          var asset = $(this).attr('href');
          var text = $(this).text();
          dataLayer.push({
            eventCategory: 'playcation family hub- home',
            eventAction: 'request playcation kids guide',
            eventLabel: text + '|' + asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Travel Quiz - Persona CTAs
        $(once('analytics', '.path-travel-quiz .paragraph-item--content-grid .button')).click(function () {
          var text = $(this).siblings('.grid-item-title').find('h2').text();
          dataLayer.push({
            eventCategory: 'experiences',
            eventAction: 'travel quiz personas',
            eventLabel: text,
            eventvalue: '',
            event: 'eventClick'
          });
        });

        // Travel Quiz - Itineraries on Experience Page
        $(once('analytics', '.page-node-type-experience .view-article-teasers a.teaser-type-article')).click(function () {
          var asset = $(this).attr('href');
          dataLayer.push({
            eventCategory: 'experiences',
            eventAction: 'itinerary',
            eventLabel: asset,
            eventvalue: '',
            event: 'eventClick'
          });
        });
      });
      //  Playcation Destination Pages
      $(once('analytics', '.page-node-type-playcation-destination-page .section--title-intro .button-wrap')).click(function () {
        var asset = $(this).find('a');
        var text = asset.text().trim();
        var href = asset.attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub- location pages',
          eventAction: text,
          eventLabel: href,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.page-node-type-playcation-destination-page .paragraph-menu ul li a')).click(function () {
        var text = $(this).text().trim();
        dataLayer.push({
          eventCategory: 'playcation family hub- location pages',
          eventAction: 'anchor links',
          eventLabel: text,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.page-node-type-playcation-destination-page .kr-partner-tab-paragraph-labels__wrapper button')).click(function () {
        var text = $(this).text();
        dataLayer.push({
          eventCategory: 'playcation family hub- location pages',
          eventAction: 'age range selection',
          eventLabel: text,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.page-node-type-playcation-destination-page .component-kr-tab__content-container')).first().find('button').click(function () {
        dataLayer.push({
          eventCategory: 'playcation family hub- location pages',
          eventAction: 'heatmap',
          eventLabel: 'zoom',
          eventvalue: '',
          event: 'eventClick'
        });
      });

      $(once('analytics', '.page-node-type-playcation-destination-page .link-wrap a')).click(function () {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub- location pages',
          eventAction: 'kid reviewed process',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.page-node-type-playcation-destination-page .component-kr-reviews__cta-container button')).click(function () {
        var text = $(this).text().trim();
        dataLayer.push({
          eventCategory: 'playcation family hub- location pages',
          eventAction: 'see more reviews',
          eventLabel: text,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.page-node-type-playcation-destination-page .component-video-slide--wrapper')).find('a.play-button-overlay').click(function (e) {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub- location pages',
          eventAction: 'video play',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.page-node-type-playcation-destination-page .section--crowdriff .section--see-all-destinations a')).click(function () {
        var asset = $(this).attr('href');
        var text = $(this).text();
        dataLayer.push({
          eventCategory: 'playcation family hub- location pages',
          eventAction: text,
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.page-node-type-playcation-destination-page .paragraph-item--toy-catalog-toy .toy-details a')).click(function () {
        var asset = $(this).attr('href');
        var text = $(this).text();
        dataLayer.push({
          eventCategory: 'playcation family hub- location pages',
          eventAction: text,
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });

      // Butterfly Ticket Redemption
      $(once('analytics', '.path-experiences-family-playcation-butterfly-ticket-redeem #edit-markup a')).click(function (e) {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub-butterfly ticket submission',
          eventAction: 'terms & conditions',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-playcation-butterfly-ticket-redeem .webform-button--submit')).click(function (e) {
        dataLayer.push({
          eventCategory: 'playcation family hub-butterfly ticket submission',
          eventAction: 'butterfly ticket submission',
          eventLabel: 'butterfly ticket submission success',
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-playcation-butterfly-ticket-redeem-success a.teaser-type-article')).click(function (e) {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub-butterfly ticket confirmation',
          eventAction: 'article carousel',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      // Playcation Destination Listing Page
      $(once('analytics', '.path-experiences-family-destinations .view-button a.button')).click(function (e) {
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'load more',
          eventLabel: 'load more locations',
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-destinations .block-tc-callout-band a')).click(function (e) {
        var asset = $(this).attr('href');
        var text = $(this).text();
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'request playcation kid\'s guide',
          eventLabel: text + ' | ' + asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-destinations .component-cta-w-image.flip a.button')).click(function (e) {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'submit your art',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-destinations .component-cta-w-image:not(.flip) a.button')).click(function (e) {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'see the toys',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-destination .component-accordion-item__title-wrapper')).click(function () {
        var status = $(this).attr('aria-selected') === 'true' ? 'open' : 'close';
        var asset = $(this).find('.component-accordion-item__title').text().trim();
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'faq ' + status,
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      // Ideas - Kid Art Form page
      $(once('analytics', '.path-experiences-family-ideas .ideas--brick-text a')).click(function (e) {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub-ugc art',
          eventAction: 'download template',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-ideas #edit-submit')).click(function (e) {
        dataLayer.push({
          eventCategory: 'playcation family hub-ugc art',
          eventAction: 'submit your art',
          eventLabel: 'submit ugc succes',
          eventvalue: '',
          event: 'eventClick'
        });
      });

      // Toy Catalog - Kid Reviewed Popup - First Visit
      $(once('analytics', '#block-tnvacation-toycatalogpopuplarge .component-campaign-grid-item--content a')).click(function () {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'kid reviewed',
          eventAction: 'first time user pop-up',
          eventLabel: 'Reserve Yours Now|' + asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      // Toy Catalog - Kid Reviewed Popup
      $(once('analytics', '#block-toycatalogpopup .component-campaign-grid-item--content a')).click(function () {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'kid reviewed',
          eventAction: 'repeat visitor pop-up',
          eventLabel: 'Reserve Yours Now|' + asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '#block-guidepromo-2 a')).click(function () {
        dataLayer.push({
          eventCategory: 'retire tennessee footer',
          eventAction: 'vacation guide',
          eventLabel: 'Order Your Guide - /guide/',
          eventvalue: '',
          event: 'eventClick'
        });
      });
      // Trip Inspiration - Newest Articles Pagination
      // This lives outside tnvacation_analytics_functions() so that it will fire when the pagination reloads via ajax.
      $(once('analytics', '.path-trip-inspiration .view-display-id-newest .pager a')).click(function () {
        var asset = $(this).clone().find('[aria-hidden="true"]').remove().end().text().replace(/\s+/g, ' ').trim();
        dataLayer.push({
          eventCategory: 'trip inspiration',
          eventAction: 'select newest',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });

      // Boots and Hearts Giveaway Form
      $(once('analytics', 'form[id*=webform-submission-boots-and-hearts] input#edit-actions-submit')).click(function () {
        dataLayer.push({
          eventCategory: 'boots & hearts',
          eventAction: 'giveaway lead form',
          eventLabel: 'successful submit',
          eventvalue: '',
          event: 'eventClick'
        });

      });
      // experiences/family
      $(once('analytics', '.landing-page--family-hub .component-cta-w-image.opt-2 a.button')).click(function () {
        var asset = $(this).attr('href');
        var text = $(this).text().trim();
        dataLayer.push({
          eventCategory: 'playcation family hub- home',
          eventAction: text,
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.landing-page--family-hub:not(.path-playcation-catalog-success) .component-cta-w-image.fifty-fifty a.button')).click(function () {
        var asset = $(this).attr('href');
        var text = $(this).text().trim();
        var label = `${text} | ${asset}`;
        dataLayer.push({
          eventCategory: 'playcation family hub- home',
          eventAction: 'request playcation kid\'s guide',
          eventLabel: label,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.view-article-teasers.view-display-id-block_4 .view-content a')).click(function (e) {
        const currentPath = window.location.pathname;
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'need more inspiration carousel',
          eventAction: 'Read Now',
          eventLabel: currentPath + ' | ' + asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.landing-page--family-hub .component-cta-w-image.no-flip a.button')).click(function () {
        var asset = $(this).attr('href');
        var text = $(this).text().trim();
        dataLayer.push({
          eventCategory: 'playcation family hub- home',
          eventAction: text,
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      // Family Destinations/Laugh Tracker;
      $(once('analytics', '.page-node-type-kid-reviewed-landing-page .kr-process-video__wrapper a.kr-process-video__play-button')).click(function () {
        var asset = $('.page-node-type-kid-reviewed-landing-page .kr-process-video__wrapper').find('iframe').attr('src');
        dataLayer.push({
          eventCategory: 'playcation family hub- kid reviewed process',
          eventAction: 'video play',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      // Experience / Family / Destinations;
      $(once('analytics', '.path-experiences-family-destinations .play-filter--dropdown p.play-filter--option')).click(function () {
        var text = $(this).text().trim();
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'filter by area',
          eventLabel: text,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-destinations .view-content.hide-extra article')).click(function (e) {
        var text = this.children[2].textContent.trim();
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'location selection',
          eventLabel: text,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-destinations .view-button button')).click(function () {
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'load more',
          eventLabel: 'load more locations',
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-destinations .block--tc-callout-band .content')).find('a').click(function () {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'request playcation kid\'s guide',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-destinations .component-cta-w-image__content')).eq(0).find('a').click(function () {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'submit your art',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-experiences-family-destinations .paragraph-content-wrapper')).eq(1).find('a').click(function () {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'see the toys',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.landing-page--bike-tn--consumer .bike-tn--topography-background.blue .biketn-content')).find('a').click(function (e) {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'bike tn- home',
          eventAction: 'learn more',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-cities-regions .block-list-cities-regions .region')).click(function (e) {
        var href = $(this).attr('href');
        var parsedText = href.split('/');
        var text = parsedText[parsedText.length - 1];
        dataLayer.push({
          eventCategory: 'cities and regions',
          eventAction: 'region selection',
          eventLabel: text,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-cities-regions .block-list-cities-regions .city')).click(function (e) {
        var href = $(this).attr('href');
        var parsedText = href.split('/');
        var text = parsedText[parsedText.length - 1];
        dataLayer.push({
          eventCategory: 'cities and regions',
          eventAction: 'city selection',
          eventLabel: text,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(document).on('click', '.path-cities-regions .ui-menu#ui-id-2 li', function (e) {
        var text = $(this).text().trim();
        dataLayer.push({
          eventCategory: 'cities and regions',
          eventAction: 'search bar- drop down',
          eventLabel: text,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-cities-regions .region-nav-content .block-mega-menu:nth-child(2)')).find('a').click(function (e) {
        var asset = $(this).attr('href');
        var text = $(this).text().trim();
        dataLayer.push({
          eventCategory: 'cities and regions',
          eventAction: text,
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '[class*="path-bill-dance-signature-lakes"] .menu--bill-dance-footer-nav')).find('a').click(function (e) {
        var text = $(this).text().trim();
        dataLayer.push({
          eventCategory: 'bill dance',
          eventAction: 'universal footer',
          eventLabel: text,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      // Alt-Text Landing Page (/for-all)
      $(once('analytics', '.path-for-all .section--components a')).click(function (e) {
        var href = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'alt text',
          eventAction: 'outbound audio description video',
          eventLabel: href,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-for-all .paragraph-item--cta-image-copy-50-50 .field__item a')).click(function (e) {
        const currentPath = window.location.pathname;
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'alt text',
          eventAction: 'learn more',
          eventLabel: currentPath + ' | ' + asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
      $(once('analytics', '.path-for-all .view-id-article_teasers a')).click(function (e) {
        var asset = $(this).attr('href');
        dataLayer.push({
          eventCategory: 'alt text',
          eventAction: 'article carousel',
          eventLabel: asset,
          eventvalue: '',
          event: 'eventClick'
        });
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
